import { Component, Inject, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { LoadingBoxComponent } from '../../../../../shared/components/loading-box/loading-box.component';
import { ImpressaoPessoaService } from '../../../../../shared/services/apis/pessoa/impressao-pessoa.service';
import { PessoaListaRequest } from '../../../../../shared/services/requests/pessoa/pessoa-lista.request';
import { PessoaImpressaoStruct } from '../../../../../shared/services/structs/pessoa/pessoa-impressao.struct';
import { CpfCnpjPipe } from '../../../../../shared/pipes/cpf-cnpj.pipe';
import { FoneMaskPipe } from '../../../../../shared/pipes/fone-mask.pipe';
import { AlertService, AlertType } from '../../../../../shared/services/alert.service';
import { LoadingBoxDefaultListComponent } from '../../../../../shared/components/loading-box-default-list/loading-box-default-list.component';

export interface ImpressaoListaSimplesData {
  filtros: PessoaListaRequest;
}

@Component({
  selector: 'app-impressao-lista-simples',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    CpfCnpjPipe,
    FoneMaskPipe,
    LoadingBoxComponent,
  ],
  templateUrl: './impressao-lista-simples.component.html',
  styleUrls: ['./impressao-lista-simples.component.css'],
})
export class ImpressaoListaSimplesComponent implements OnInit {
  public isLoading: boolean = false;
  public relatorioSimples: PessoaImpressaoStruct[] = [];
  public displayedColumns: string[] = ['nome', 'fantasia', 'documento', 'cidade', 'contato', 'email'];

  constructor(
    public dialogRef: MatDialogRef<ImpressaoListaSimplesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ImpressaoListaSimplesData,
    private impressaoService: ImpressaoPessoaService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.buscarRelatorioSimples();
  }

  private buscarRelatorioSimples(): void {
    this.isLoading = true;
    const request = new PessoaListaRequest();
    Object.assign(request, this.data.filtros);

    this.impressaoService.getListaSimples(request).subscribe({
      next: res => {
        this.isLoading = false;
        if (!res.isError) {
          this.relatorioSimples = res.listaPessoasImpressao || [];
        } else {
          this.alertService.show('Erro', res.errorDescription, AlertType.error);
          this.fechar();
        }
      },
      error: err => {
        this.isLoading = false;
        this.alertService.show('Erro', 'Erro ao gerar relatório simples', AlertType.error);
        this.fechar();
      },
    });
  }

  public imprimir(): void {
    const conteudoParaImprimir = document.querySelector('.modal-print-container');

    if (conteudoParaImprimir) {
      const janelaImpressao = window.open('', '', 'height=600,width=800');

      if (janelaImpressao) {
        // Collect all stylesheets from the current document
        const styles = Array.from(document.styleSheets)
          .map(styleSheet => {
            try {
              return Array.from(styleSheet.cssRules)
                .map(rule => rule.cssText)
                .join('');
            } catch (e) {
              return '';
            }
          })
          .join('');

        janelaImpressao.document.write(`
          <html>
            <head>
              <title>Imprimir Lista</title>
              <base href="/">
              <style>
                ${styles}
                /* Print Specific Overrides */
                html, body {
                    height: auto !important;
                    min-height: 0 !important;
                    overflow: visible !important;
                    margin: 0 !important;
                    font-family: Roboto, "Helvetica Neue", sans-serif;
                    color: #000;
                    background: #fff;
                }
                .no-print { display: none !important; }
                .modal-print-container {
                    display: block !important;
                    width: 100% !important;
                    height: auto !important;
                    min-height: 0 !important;
                    overflow: visible !important;
                    box-shadow: none !important;
                    margin: 0 !important;
                    padding: 0 !important;
                }
                
                /* Force MatTable styles for print if needed */
                .mat-mdc-table { background: white !important; table-layout: fixed !important; width: 100% !important; }
                .mat-mdc-header-cell { color: black !important; font-weight: bold !important; border-bottom: 2px solid black !important; }
                .mat-mdc-cell { color: black !important; border-bottom: 1px solid #ddd !important; }
                th, td {
                    overflow-wrap: anywhere !important;
                    word-break: break-word !important;
                    white-space: normal !important;
                    padding: 4px 6px !important;
                    font-size: 12px !important;
                }
                .table-responsive { overflow: visible !important; }
                @page { size: A4 portrait; margin: 8mm; }

                .title-header { text-align: center; margin-bottom: 20px; }
                h2 { font-size: 16px; margin: 0; }
              </style>
            </head>
            <body>
              ${conteudoParaImprimir.innerHTML}
            </body>
          </html>
        `);

        janelaImpressao.document.close();
        janelaImpressao.focus();

        setTimeout(() => {
          janelaImpressao.print();
          janelaImpressao.close();
        }, 800);
      }
    }
  }

  public fechar(): void {
    this.dialogRef.close();
  }
}
